// Styles for MapViewSlider go here.
import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import { miniCardHeight, miniCardWidth } from '../../modules/constants/constant';

export const StyledMapViewSlider = styled.div<{
  containerWidth: number;
  miniCardLength: number;
}>`
  width: 100%;
  position: absolute;
  bottom: ${toRem(60)};
  z-index: 10;
  right: 0;
  left: 0;

  @media ${baseVariables.mediaQuery.md} {
    position: initial;
  }

  .carousel-container {
   width: 100%
    overflow: hidden;
  }

  .carousel__slider-tray {
   width: 100%;
  }

  .search-mini-card {
    border-radius: ${toRem(14)};
  }

  .minicard__image {
    border-radius: ${toRem(14)} 0 0 ${toRem(14)};
  }

  .no-animation {
    transition: none !important;
  }

  .carousel-slider {
    width: 100%;
    min-height: ${toRem(miniCardHeight)};
    box-sizing: border-box;
    /* Uniform card height: tray uses flex + align-items: stretch (from isIntrinsicHeight) */
    .carousel__inner-slide {
      height: 100%;
      display: flex;
      .carousel__slide-focus-ring {
        outline-style: none;
      }
    }
  }

  .slide-container {
    width: ${toRem(miniCardWidth)};
    min-width: ${toRem(miniCardWidth)};
    height: 100%;
  }

  /* Propagate height to HotelCard for uniform card heights */
  .slide-container [data-component-name='m-luxury-HotelCard'] {
    height: 100%;
    width: 100%;
  }
  .slide-container [data-component-name='m-luxury-HotelCard'] .hotel-card-container {
    height: 100%;
  }
`;
